import script from "./BindCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./BindCode.vue?vue&type=script&setup=true&lang=ts"

import "./BindCode.vue?vue&type=style&index=0&id=f89de74e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.3.1_@vue+comp_8f2c4c49f6fda9a4fff749d98711c87c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f89de74e"]])

export default __exports__